import React, { useState } from 'react'

const usePagedView = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [numPages, setNumPages] = useState(1)

  const isLastPage = currentPage + 1 > numPages
  const isFirstPage = currentPage - 1 < 1

  const nextPage = () => {
    if (!isLastPage) setCurrentPage(currentPage + 1)
  }
  const prevPage = () => {
    if (!isFirstPage) setCurrentPage(currentPage - 1)
  }

  return {
    numPages,
    setNumPages,
    currentPage,
    nextPage,
    prevPage,
    setCurrentPage,
  }
}

export default usePagedView
